import { useTranslation } from "react-i18next"
import { useMemo } from "react"
import { format } from "date-fns"

import Dialog from "@/components/dialog/Dialog"
import BasicButton from "@/components/button/BasicButton"
import TextField from "@/components/form/textField/TextField"
import { createAccountStore } from "@/stores/account"
import { createGlobalStore } from "@/stores/global"
import { DATE_FORMAT } from "@/constants/date"

import "./OpenAPIDialog.scss"

export default function OpenAPIDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation("")
  const { teamProfileInfo } = createAccountStore()
  const { setSnackBar } = createGlobalStore((store) => ({
    setSnackBar: store.setSnackBar,
  }))

  const apiUrl = useMemo(() => {
    if (!teamProfileInfo) return "-"

    const apiEndpoint = import.meta.env.VITE_API_ENDPOINT
    return `${apiEndpoint}/openapi/activities?date=${format(new Date(), DATE_FORMAT)}`
  }, [teamProfileInfo])

  const uuid = useMemo(() => {
    return teamProfileInfo?.openapiId ?? "-"
  }, [teamProfileInfo])

  const handleClose = () => {
    onClose()
  }

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(apiUrl)
      setSnackBar({ message: t("messages.copied"), severity: "success", open: true })
    } catch (error) {
      console.error("Failed to copy URL:", error)
    }
  }

  const handleCopyUuid = async () => {
    try {
      await navigator.clipboard.writeText(uuid)
      setSnackBar({ message: t("messages.copied"), severity: "success", open: true })
    } catch (error) {
      console.error("Failed to copy UUID:", error)
    }
  }

  return (
    <Dialog
      className="OpenAPIDialogCont"
      title="Open API"
      open={open}
      onClose={handleClose}
      maxWidth="600px"
      footer={
        <BasicButton type="default-outlined" size="md" onClick={handleClose}>
          {t("button.close")}
        </BasicButton>
      }>
      <div className="openapi-dialog-row">
        <TextField label="Open API URL" disabled value={apiUrl} fullWidth />
        <BasicButton type="primary-outlined" size="md" onClick={handleCopyUrl}>
          {t("button.copy")}
        </BasicButton>
      </div>
      <div className="openapi-dialog-row">
        <TextField label="UUID" disabled value={uuid} fullWidth />
        <BasicButton type="primary-outlined" size="md" onClick={handleCopyUuid}>
          {t("button.copy")}
        </BasicButton>
      </div>
    </Dialog>
  )
}
